<template>
    <a href="#menu" @click.prevent="toggleMenu">
        <slot></slot>
    </a>
</template>

<script>
import { bus } from '@/app';

export default {
    name: "Ui.MenuToggle",

    methods: {
        toggleMenu() {
            bus.$emit('slideout', 'menu');
        }
    }
}
</script>